import styled from 'styled-components';

export const Wrapper = styled.div`
	width: 80vw;
	height: 100vh;
	background: ${(props) => (props.bg ? props.bg : '#333')};
	display: flex;
	// margin-top: -1.5rem;
	// margin-bottom: -1.5rem;
	margin-left: -8rem;
	overflow-y: auto !important;

	@media screen and (max-width: 500px) {
		overflow-x: auto !important;
	}

	@media screen and (max-width: 950px) {
		background: ${(props) => props.bg1 && props.bg1};
	}

	@media screen and (max-width: 768px) {
		background: ${(props) => props.bg2 && props.bg2};
	}
`;
